module.exports = require("@wildboar/x500/src/lib/modules/InformationFramework/subschemaSubentryList.oa");